import { isNotEmptyOrNull } from "../../core/utils/functions.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import clsx$1 from "clsx";
import { FiBell } from "react-icons/fi";
import { IoMdCalendar } from "react-icons/io";
//#region src/modules/notifications/components/item.tsx
var Item = ({ notification }) => {
	return /* @__PURE__ */ jsxs("a", {
		className: clsx$1("hover:bg-secondary-light rounded-micro m-mili no-underline", { "hover:cursor-none": !isNotEmptyOrNull(notification.link) }),
		href: notification.link,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "p-mili",
			children: [/* @__PURE__ */ jsx("p", {
				className: "text-base font-bold text-secondary-xdark",
				children: notification.titulo
			}), /* @__PURE__ */ jsx("p", {
				className: "text-sub text-secondary-xdark",
				dangerouslySetInnerHTML: { __html: notification.texto }
			})]
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex justify-between px-mili py-micro",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex items-center gap-x-micro text-secondary-medium",
				children: [/* @__PURE__ */ jsx(IoMdCalendar, {}), /* @__PURE__ */ jsx("p", {
					className: "text-sub",
					children: notification.data
				})]
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex items-center gap-x-micro text-secondary-medium",
				children: [/* @__PURE__ */ jsx(FiBell, {}), /* @__PURE__ */ jsx("p", {
					className: "text-sub",
					children: notification.produto
				})]
			})]
		})]
	});
};
//#endregion
export { Item };
